import { Directive, ElementRef , HostListener, Input } from '@angular/core';
import {UserService} from '../_services/user.service';
import { Router} from '@angular/router';
import { environment } from '../../environments/environment';
import {CommonFunctionsService, NgxToasterService} from '../_services/index';
import { timer} from 'rxjs';
import {  TextSetting } from '../textsetting';

declare var $: any;

@Directive({
	selector: '[appLogout]',
})
export class LogoutDirective {
	TextSetting          = TextSetting;

	constructor(
		private el: ElementRef,
		public router: Router,
		public userService: UserService,
		private toasterNotification     : NgxToasterService,
		private commonFunctionsService: CommonFunctionsService
	) { }

	@HostListener('click') onClick(): void {
		this.logout();
	}


	// This function for logout
	private logout(): void {
		this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
			if (isBrowser){
				const that		=	this;
				that.userService.purgeAuth();
				timer(1000).subscribe(() => {
					that.toasterNotification.showSuccess(that.TextSetting.SUCCESS_LOGOUT);
				});
				that.router.navigate(['/']);
				setTimeout(()=>{
					$(".flexnav").flexNav();
					$('.menu-button').click(()=>{
						$('.menu-button').toggleClass('open');
						$('body').toggleClass('stop-scroll');
					});
				},1000);
			}
		});
	}
}
